import * as TypeGraphQL from "type-graphql";
export var NullableJsonNullValueInput;
(function (NullableJsonNullValueInput) {
    NullableJsonNullValueInput["DbNull"] = "DbNull";
    NullableJsonNullValueInput["JsonNull"] = "JsonNull";
})(NullableJsonNullValueInput || (NullableJsonNullValueInput = {}));
TypeGraphQL.registerEnumType(NullableJsonNullValueInput, {
    name: "NullableJsonNullValueInput",
    description: undefined,
});
//# sourceMappingURL=NullableJsonNullValueInput.js.map